import React from "react";
import { captureError } from "./lib/analytics";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
    // Report the render crash to Sentry (no-op without a DSN) so it doesn't fail silently.
    captureError(error, { componentStack: info?.componentStack || "" });
    // Surface to server-side logs if we have an API URL configured
    try {
      const url = process.env.REACT_APP_API_URL;
      if (url) {
        fetch(`${url}/client-error`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message: error?.message || String(error),
            stack: error?.stack || "",
            componentStack: info?.componentStack || "",
            url: window.location.href,
            ua: navigator.userAgent,
          }),
        }).catch(() => {});
      }
    } catch (_) { /* noop */ }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Geist', sans-serif",
          padding: "24px",
          textAlign: "center",
          background: "#faf7f2",
        }}>
          <div style={{ fontFamily: "'Fraunces', serif", fontSize: 32, fontWeight: 500, marginBottom: 12 }}>
            Pitcher<em style={{ color: "#1E40AF", fontStyle: "italic" }}>ly</em>
          </div>
          <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 10, color: "#1a1a1a" }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 14, color: "#666", marginBottom: 24, maxWidth: 440, lineHeight: 1.5 }}>
            The app hit an unexpected error. Your work is saved — try reloading, or head back to the home page.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={this.handleReload}
              style={{ padding: "10px 20px", background: "#1E40AF", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: 600 }}
            >
              Reload
            </button>
            <button
              onClick={this.handleHome}
              style={{ padding: "10px 20px", background: "transparent", color: "#1a1a1a", border: "1px solid #ddd", borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: 600 }}
            >
              Go home
            </button>
          </div>
          {this.state.error?.message && (
            <details style={{ marginTop: 28, fontSize: 12, color: "#999", maxWidth: 500 }}>
              <summary style={{ cursor: "pointer" }}>Error details</summary>
              <pre style={{ whiteSpace: "pre-wrap", textAlign: "left", marginTop: 8 }}>
                {this.state.error.message}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
